import { generateTotalExpression, getNumberValue } from 'utilities';
import { GetInvestmentsExpressionsParams } from './getInvestmentsExpressions.types';

const getInvestmentsExpressions = (params: GetInvestmentsExpressionsParams) => {
  const {
    areFundInvestmentsEnabled,
    companyCount,
    directInvestmentExcludedRowsCount,
    fundInvestmentCount,
    fundInvestmentExcludedRowsCount,
  } = params;

  // Generate rows for direct investments

  const directInvestmentsRows = Array.from(
    { length: companyCount },
    (_, index) =>
      areFundInvestmentsEnabled
        ? fundInvestmentExcludedRowsCount + index + 1 // +1 for 1-based indexing
        : directInvestmentExcludedRowsCount + index + 1 // +1 for 1-based indexing
  );

  const directInvestmentsExpression = generateTotalExpression({
    items: directInvestmentsRows,
    generateIndex: false,
  });

  const directInvestmentsTotalRow = getNumberValue(directInvestmentsRows.at(-1)) + 1;

  const directInvestmentsTotalExpression = generateTotalExpression({
    items: [directInvestmentsTotalRow],
    generateIndex: false,
  });

  // Generate rows for fund investments

  const hasCompany = directInvestmentsRows.length > 0;

  const fundInvestmentsStartRow = hasCompany
    ? getNumberValue(directInvestmentsRows.at(-1)) + fundInvestmentExcludedRowsCount + 1 // +1 for 1-based indexing
    : fundInvestmentExcludedRowsCount + 1; // +1 for 1-based indexing;

  const fundInvestmentsRows = Array.from(
    { length: fundInvestmentCount },
    (_, index) => fundInvestmentsStartRow + index
  );

  const fundInvestmentsExpression = generateTotalExpression({
    items: fundInvestmentsRows,
    generateIndex: false,
  });

  const fundInvestmentsTotalRow = getNumberValue(fundInvestmentsRows.at(-1)) + 1;

  const fundInvestmentsTotalExpression = generateTotalExpression({
    items: [fundInvestmentsTotalRow],
    generateIndex: false,
  });

  const directAndFundInvestmentsTotalExpression = [
    ...directInvestmentsTotalExpression,
    ...fundInvestmentsTotalExpression,
  ];

  return {
    directAndFundInvestmentsTotalExpression,
    directInvestmentsExpression,
    fundInvestmentsExpression,
  };
};

export default getInvestmentsExpressions;
